import {types} from './types';

const initialState = {
    list: {
        data: [],
        currentPage: 0,
        currentRowsPerpage: 0,
        total: 0,
        totalPage: 0
    },
    view: {}
}

export function paymentsReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_GET_PAYMENTS:
            return { ...state, list: action.payload};
        case types.SET_GET_PAYMENTS_BY_ID:
            return { ...state, view: action.payload};
        default:
            return state
    }
}